<template>
    <div class="tAndC">
        <div class="payment-status" v-if="adsDetail && adsDetail.orderState ==='PAYMENT_SUCCESSFUL'">
            <figure class="img-wrapr">
                <img src="../assets/images/icons/check-mark-success.gif" />
            </figure>
            <span>Rs.{{adsDetail.totalAmount}} has been added to your ADS Wallet</span>
            <p class="go-to-home" @click="$router.replace('/manage-shops?showLocalShop=true')">Go to home</p>
        </div>
        <div class="payment-status" v-else-if="adsDetail && adsDetail.orderState !=='PAYMENT_SUCCESSFUL'">
            <figure class="img-wrapr">
                <img src="../assets/images/icons/payment-failed.svg" />
            </figure>
            <span class="red">Payment Failed. Please try again!</span>   
            <p class="go-to-home" @click="$router.replace('/manage-shops?showLocalShop=true')">Go to home</p>         
        </div>
        <div v-else>
            <loadingIcon v-if="loading" />
        </div>
    </div>
</template>

<script>
import Toaster from '../components/Toaster';
import loadingIcon from '../components/Icons/loadingIcon';
import { SessionHelper } from '../services/Session';
import ApiRequest from '../services/ApiRequest';
import constant from '../utils/constant';
export default {
    name: 'AdsOrderDetail',
    components: {
        Toaster,
        loadingIcon,
    },
    data() {
        return {
        adsDetail: null,
        toasterData: {},
        loading: true,
        adBannerStatus: false,
        isDisable: false
        };
    },
    methods: {
        getAdsOrderDetail(){
            ApiRequest(constant.ADS_BASE_URL2,`orderService/get-order-by-order-id/${this.$route.query.orderId}`, "get").then((data) => {
                this.adsDetail = data;
            }).catch(err=>{
                if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
                try {
                    SessionHelper.refereshJwtToken();
                    if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
                    this.getAdsOrderDetail();
                    }
                } catch (err) {
                    this.loading = false;
                    console.log(err);
                }
                }
            })
        }
    },
    mounted(){
        this.getAdsOrderDetail()
    }
}
</script>

<style lang="scss" scoped>
.payment-status{    
    position: absolute;
    top: 50%;
    left: 50%;
    width: 70%;
    transform: translate(-50% , -50%);
    text-align: center;
    .img-wrapr{
        width: 60%;
        margin: 8px auto;
        img{
            max-width: 100%;
            max-height: 100%;
        }
    }
    span{
        color: #515ed5;
        font-weight: 600;
        &.red{
            color: red;
        }
    }
    .go-to-home{
        width: max-content;
        margin: 8px auto;
        border: 1px solid black;
        padding: 8px 15px;
        border-radius: 5px;
        color: orange;
        font-weight: 600;
    }

}
</style>